﻿/**
 * Retrieves a required element and throws an error if not found.
 */
export const getRequiredElement = <T extends Element>(
  parent: Document | Element,
  selector: string,
  errorMessage?: string
): T => {
  const element = parent.querySelector<T>(selector);

  if (!element) {
    throw new Error(errorMessage ?? `Could not find required selector: ${selector}`);
  }

  return element;
};

/**
 * Retrieves a required attribute from an element and throws an error if missing.
 */
export const getRequiredAttribute = (
  element: Element,
  attribute: string,
  errorMessage: string
): string => {
  const value = element.getAttribute(attribute);
  if (!value) {
    throw new Error(errorMessage);
  }
  return value;
};

/**
 * Retrieves a required data attribute from an element and throws an error if missing.
 */
export const getRequiredDatasetAttribute = (
  element: HTMLElement,
  datasetKey: keyof typeof element.dataset,
  errorMessage: string
): string => {
  const value = element.dataset[datasetKey];
  if (!value) {
    throw new Error(errorMessage);
  }
  return value;
};
